import React, { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { TenantThemeConfig } from '../types/theme'
import { getActiveLiveTvChannels } from '../lib/liveTv'
import { parseYoutubeVideoId, toYoutubeEmbedUrl } from '../lib/youtubeUrl'

interface LiveTvPageProps {
  themeConfig: TenantThemeConfig
}

const LiveTvPage: React.FC<LiveTvPageProps> = ({ themeConfig }) => {
  const navigate = useNavigate()
  const channels = useMemo(() => {
    if (themeConfig.settings.liveTvEnabled !== true) return []
    return getActiveLiveTvChannels(themeConfig.settings.liveTvChannels || [])
  }, [themeConfig.settings.liveTvEnabled, themeConfig.settings.liveTvChannels])
  const [selectedId, setSelectedId] = useState<string | null>(channels[0]?.id || null)

  const selected = channels.find((channel) => channel.id === selectedId) || channels[0] || null
  const videoId = selected ? parseYoutubeVideoId(selected.youtubeUrl) : null

  return (
    <div className="container py-3">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          <h4 className="mb-1 c-dark font_md">ดูถ่ายทอดสด</h4>
          <p className="mb-0 text-muted small">ช่องบอล / กีฬา — อัปเดตโดยแอดมิน</p>
        </div>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={() => navigate('/dashboard')}>
          กลับหน้าหลัก
        </button>
      </div>

      {channels.length === 0 ? (
        <div className="card bx-sd border-0 p-4 text-center">
          <i className="fas fa-tv fs-28 text-muted mb-3" />
          <p className="mb-0 text-muted">ยังไม่มีช่องถ่ายทอดสดในขณะนี้</p>
        </div>
      ) : (
        <>
          <div className="row g-2 mb-3">
            {channels.map((channel) => (
              <div key={channel.id} className="col-6 col-md-4">
                <button
                  type="button"
                  className={`check-button w-100 d-block text-start ${selected?.id === channel.id ? 'bgc-2 c-white' : 'bgc-4 c-dark'} bx-sd`}
                  onClick={() => setSelectedId(channel.id)}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-bold">{channel.title}</span>
                    <span className="badge bg-danger animate__animated animate__pulse animate__infinite">LIVE</span>
                  </div>
                </button>
              </div>
            ))}
          </div>

          {selected && videoId && (
            <div className="card bx-sd border-0 overflow-hidden">
              <div className="card-header bg-dark text-white d-flex justify-content-between align-items-center">
                <span>{selected.title}</span>
                <span className="small"><i className="fas fa-circle text-danger me-1" />ถ่ายทอดสด</span>
              </div>
              <div className="ratio ratio-16x9 bg-black">
                <iframe
                  title={selected.title}
                  src={toYoutubeEmbedUrl(videoId, { autoplay: true })}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  style={{ border: 0 }}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default LiveTvPage
